import type { TripsResponse } from '@transp/shared'
import { useEffect, useState } from 'react'

export type TripsQuery = { day: string; from: string; to: string; lines: string[] }

type State =
	| { status: 'loading' }
	| { status: 'error'; message: string }
	| { status: 'ready'; data: TripsResponse }

export function useTrips(q: TripsQuery): State {
	const [state, setState] = useState<State>({ status: 'loading' })
	// `lines` e um array novo a cada render, entao ele nao serve como dependencia: o
	// efeito refaria a consulta em todo render. A chave textual e estavel por valor.
	const linesKey = q.lines.join(',')

	useEffect(() => {
		const ctl = new AbortController()
		const url = `/api/trips?dia=${q.day}&de=${q.from}&ate=${q.to}&linhas=${linesKey}`
		setState({ status: 'loading' })
		fetch(url, { signal: ctl.signal })
			.then(async (r) => {
				if (!r.ok) throw new Error(`${r.status}: ${await r.text()}`)
				return (await r.json()) as TripsResponse
			})
			.then((data) => setState({ status: 'ready', data }))
			.catch((err: unknown) => {
				if (ctl.signal.aborted) return
				setState({ status: 'error', message: String(err) })
			})
		return () => ctl.abort()
	}, [q.day, q.from, q.to, linesKey])

	return state
}
